<template>
  <div>
    <spinner v-if="loading" />
    <div v-else>
    <div class="row">
      <div class="col-sm-10"></div>
      <div class="col-sm-2">
        <CustomSelect
          name="filterBy"
          placeholder="Filter By"
          :optionLabel="'name'"
          :options="providerStatFilter"
          v-model="filterBy"
        />
      </div>
    </div>
    <div>
      <apexchart
        height="400"
        width="1400"
        type="bar"
        :options="{
          plotOptions: {
            bar: {
              borderRadius: 0,
            },
          },
        }"
        :series="[
            {
              data: chartData.map((dt) => ({
                x: dt.log_date,
                y: dt.log_count,
              })),
            },
        ]"
      ></apexchart>
    </div>
  </div>
  </div>
</template>

<script>
import {
  toCurrency,
  formatNumber,
  graphDateFormatter,
  providerStatFilter,
} from "../utils/helpers";
import CustomSelect from "../utils/CustomSelect/CustomSelect";
import logs from "../../services/logs";
import Spinner from "../utils/Spinner/Spinner";

export default {
  name: "ProviderLogStat",
  data() {
    return {
      loading: false,
      chartData: [],
      filterBy: "thisMonth",
      providerStatFilter,
    };
  },
  components: { CustomSelect, Spinner },
  methods: {
    toCurrency,
    formatNumber,
    graphDateFormatter,
    async fetchCreditLogStat(filterBy) {
      this.loading = true
      const { data } = await logs.GetProviderLogStats(filterBy);
      this.chartData = data.data;
      this.loading = false;
    },
  },
  watch: {
    filterBy(newVal, oldVal) {
      this.fetchCreditLogStat({
        filterBy: newVal.value,
      });
    },
  },
  created() {
    this.fetchCreditLogStat({
      filterBy: this.filterBy,
    });
  },
};
</script>

<style scoped></style>